var map = {
	"./diamond-cut-1@2x.jpg": 56,
	"./diamond-cut-2@2x.jpg": 58,
	"./diamond-cut-3@2x.jpg": 60,
	"./diamond-cut-4@2x.jpg": 62,
	"./diamond-cut-5@2x.jpg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 250;